import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import type { MarginRightProps } from 'styled-system';
import { marginRight } from 'styled-system';

import { BodyRegularBR2 } from '../Typography';
import type { ArticleSmallPriceProps } from './ArticleSmallPrice';
import RRPPrice from './RRPPrice';
import UnitPrice from './UnitPrice';

interface ArticlePriceOrderProps extends Pick<ArticleSmallPriceProps, 'rrpPrice' | 'measurement'> {
  shouldDisplayRRP: boolean;
  isOrdered?: boolean;
}

const StyledUnitPrice = styled(UnitPrice)<MarginRightProps>`
  ${marginRight};
`;

const styledUnitPrice = {
  marginRight: 'sp_4',
};

const ArticlePriceOrder = ({
  shouldDisplayRRP,
  rrpPrice,
  measurement,
  isOrdered,
}: ArticlePriceOrderProps) => {
  return (
    <Fragment>
      {shouldDisplayRRP && !isOrdered && (
        <RRPPrice rrpPrice={rrpPrice} Typography={BodyRegularBR2} />
      )}
      {measurement && (
        <StyledUnitPrice measurement={measurement} {...(isOrdered ? { ...styledUnitPrice } : {})} />
      )}
      {shouldDisplayRRP && isOrdered && <RRPPrice rrpPrice={rrpPrice} />}
    </Fragment>
  );
};

export default ArticlePriceOrder;
